import React, {Component} from 'react';
import {connect} from 'react-redux';
import {injectIntl, FormattedMessage} from 'react-intl';
import {Filters} from '../../common/filters';
import {fetchListings, UNREFINED_KEY} from '../../../actions/listings';
import {wrapInTest} from '../../common/mvt/utils/mvt';
import {TESTS, getValue} from '../../../utils/abacus';

const MIN_LISTING_COUNT = 15;
const MIN_SEGMENTS = 1;

function hasSegments(destination) {
    return destination.refinementsByType && destination.refinementsByType.segments && destination.refinementsByType.segments.length > 0;
}

function getValidSegments(segments) {
    return segments.filter((segment) => segment.count >= MIN_LISTING_COUNT);
}

function getSegments(destination) {
    if (!hasSegments(destination)) {
        return null;
    }

    const unrefinedSegment = {
        name: 'Popular',
        messageKey: UNREFINED_KEY
    };

    const validSegments = getValidSegments(destination.refinementsByType.segments);

    return validSegments.length > MIN_SEGMENTS ? [unrefinedSegment, ...validSegments] : null;
}


export function mapStateToProps(state) {
    return {
        site: state.config.site.name,
        count: 6,
        destination: state.destination,
        segments: getSegments(state.destination),
        abacus: state.abacus
    };
}

export class SegmentFiltersComponent extends Component {
    constructor(props) {
        super(props);

        this.clickHandler = this.clickHandler.bind(this);

        this.state = {
            activeFilter: UNREFINED_KEY
        };
    }

    clickHandler(segmentKey) {
        const {
            site,
            count,
            destination
        } = this.props;

        const {
            details: {
                lbsId
            }
        } = destination;

        this.props.dispatch(fetchListings(lbsId, site, count, segmentKey));
        this.setState({
            activeFilter: segmentKey
        });
    }

    getButtonClasses(isActive) {
        return isActive ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-default';
    }

    render() {
        const {
            activeFilter
        } = this.state;

        const {
            segments,
            abacus
        } = this.props;

        const displayFilters = (getValue(abacus, TESTS.SLP_2089V) === 1 && segments);

        const filters = displayFilters ? (
            <Filters>
                {
                    segments.map((segment) => (
                        <button
                            key={segment.messageKey}
                            className={this.getButtonClasses(activeFilter === segment.messageKey)}
                            onClick={this.clickHandler.bind(null, segment.messageKey)} //eslint-disable-line
                        >
                            <FormattedMessage
                                id={`module.placestostay.tag.${segment.messageKey}`}
                                defaultMessage={'Default'}
                            />
                        </button>
                    ))
                }
            </Filters>
        ) : null;

        return segments ? wrapInTest(abacus, TESTS.SLP_2089V, filters) : null;
    }
}

export const SegmentFilters = injectIntl(
    connect(mapStateToProps)(SegmentFiltersComponent)
);
